<template>
    <div class="location">
        <div class="image">
            <img :src="location.avatar" />
        </div>
        <div class="text">
            <h2 v-if="location.building_name">
                {{ location.building_name }}
            </h2>
            <p class="address">
                <span v-html="location.address.join('<br />')"></span>
            </p>

            <p class="phone">
                <a :href="`tel:${location.phone_clickable}`">{{ location.phone }}</a>
            </p>

            <div class="directions-and-distance">
                <div>
                    <div class="directions">
                        <a class="btn-outlined" style="margin: 0;" target="_blank" :href="`https://www.google.com/maps/dir/?api=1&destination=${location.coordinates['lat']},${location.coordinates['lng']}`">
                            <i aria-hidden="true" class="fas fa-map-marked-alt"></i> Get Directions
                        </a>
                        <template v-if="location.url">
                            <br>
                            <a class="btn-outlined" target="_blank" :href="location.url">
                                <i aria-hidden="true" class="fas fa-map-marked-alt"></i> Explore
                            </a>
                        </template>
                    </div>
                </div>
                <div v-if="distance" class="distance">
                    <div v-html="distance"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        location: {type: Object, required: true},
    },

    computed: {
        distance() {
            if (!this.location.distance) {
                return;
            }

            const word = this.location.distance === 1 ? 'Mile' : 'Miles';

            return `${this.location.distance} <br> <span>${word}</span>`;
        },
    },
};
</script>
